// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5d84d4f6","732":"969cc96c","977":"5f1207c9"}[chunkId] + ".chunk.js";
};